// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WhatsNewModal — the agentic-upgrade announcement. Self-contained (wnm-*),
   brand purple (#5e1bff family), DM Sans. The grid / glow / carousel / marquee
   are ported 1:1 from the Wix-onboarding brand visual (.wav-*). */

.wnm-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 92%;
  max-width: 760px;
  max-height: 94vh;
  overflow: hidden;
  border-radius: 22px;
  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);
  color: #fff;
  font-family: 'DM Sans', system-ui, sans-serif;
  box-shadow: 0 34px 90px rgba(18, 4, 52, 0.55);
  outline: none;
}

/* faint diagonal grid that fades toward the bottom — premium depth, no banding */
.wnm-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(125% 80% at 78% 0%, #000 35%, transparent 80%);
  pointer-events: none;
}
.wnm-glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(52% 38% at 82% 4%, rgba(255, 255, 255, 0.18), transparent 62%);
  pointer-events: none;
}

.wnm-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 3;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;
  font-size: 0.9rem;
  transition: background 0.2s, transform 0.2s;
}
.wnm-close:hover { background: rgba(255, 255, 255, 0.2); transform: translateY(-1px); }

.wnm-inner {
  position: relative;
  z-index: 1;
  max-height: 94vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 40px 40px 28px;
  box-sizing: border-box;
}

/* ── Header ── */
.wnm-eyebrow {
  display: inline-block;
  align-self: flex-start;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  padding: 5px 11px;
  border-radius: 999px;
  margin-bottom: 16px;
}
.wnm-title {
  font-size: 1.86rem;
  font-weight: 700;
  line-height: 1.14;
  letter-spacing: -0.018em;
  margin: 0 0 10px;
}
.wnm-sub {
  font-size: 0.96rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.82);
  margin: 0 0 22px;
  max-width: 96%;
}

/* ── Promo: the headline AI Studio, clickable straight into the builder.
   A bright, near-white card that pops against the purple, with dark text. ── */
.wnm-promo {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-align: left;
  margin: 2px 0 20px;
  padding: 18px 20px;
  border-radius: 18px;
  border: 1px solid #fff;
  background: linear-gradient(150deg, #ffffff 0%, #f3f1fb 100%);
  box-shadow: 0 18px 40px rgba(18, 4, 52, 0.42), 0 0 0 1px rgba(124, 58, 237, 0.18);
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  animation: wnm-promo-pulse 2.8s ease-in-out infinite;
}
.wnm-promo:hover {
  transform: translateY(-2px);
  box-shadow: 0 24px 52px rgba(18, 4, 52, 0.5), 0 0 0 1px rgba(124, 58, 237, 0.34);
  animation: none;
}
@keyframes wnm-promo-pulse {
  0%, 100% { box-shadow: 0 18px 40px rgba(18, 4, 52, 0.42), 0 0 0 1px rgba(124, 58, 237, 0.18), 0 0 0 0 rgba(124, 58, 237, 0.3); }
  50%      { box-shadow: 0 18px 40px rgba(18, 4, 52, 0.42), 0 0 0 1px rgba(124, 58, 237, 0.18), 0 0 0 8px rgba(124, 58, 237, 0); }
}
.wnm-promo-badge {
  position: absolute;
  top: -9px;
  left: 18px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed, #5616ea);
  padding: 4px 10px;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(86, 22, 234, 0.45);
}
.wnm-promo-icon {
  flex: 0 0 auto;
  width: 50px;
  height: 50px;
  border-radius: 13px;
  display: grid;
  place-items: center;
  font-size: 1.25rem;
  color: #fff;
  background: linear-gradient(145deg, #b794ff 0%, #6d28d9 100%);
  box-shadow: 0 6px 16px rgba(76, 24, 204, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.45);
}
.wnm-promo-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1 1 auto; }
.wnm-promo-title { font-size: 1.18rem; font-weight: 800; letter-spacing: -0.01em; color: #1c1535; }
.wnm-promo-desc { font-size: 0.85rem; line-height: 1.4; color: #5b5570; }
.wnm-promo-cta {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 11px;
  background: #5616ea;
  color: #fff;
  font-size: 0.86rem;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 8px 20px rgba(86, 22, 234, 0.4);
  transition: transform 0.18s ease;
}
.wnm-promo:hover .wnm-promo-cta { transform: translateX(2px); }

/* ── Marquee: everything the agent connects to ── */
.wnm-more { margin-top: 22px; }
.wnm-more-label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}
.wnm-marquee {
  margin-top: 12px;
  /* Vertical room so a logo's hover-lift isn't clipped by overflow: hidden. */
  padding: 8px 0;
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
}
.wnm-marquee-track {
  display: flex;
  width: max-content;
  animation: wnm-marquee 28s linear infinite;
}
.wnm-marquee:hover .wnm-marquee-track { animation-play-state: paused; }
/* Each logo is wrapped in InfoTooltip — its .info-tooltip-wrapper is the flex item,
   so the loop spacing lives on the wrapper (the duplicated track still slides -50%). */
.wnm-marquee-track .info-tooltip-wrapper {
  flex: 0 0 auto;
  margin: 0 9px 0 0;
}
.wnm-more-logo {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #fff;
  display: grid;
  place-items: center;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.wnm-more-logo:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);
}
.wnm-more-logo img { width: 21px; height: 21px; object-fit: contain; }
@keyframes wnm-marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

/* ── Calendly CTA ── */
.wnm-cta {
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
}
.wnm-cta-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.wnm-cta-title { font-size: 1rem; font-weight: 700; letter-spacing: -0.01em; }
.wnm-cta-sub { font-size: 0.84rem; line-height: 1.4; color: rgba(255, 255, 255, 0.8); }
.wnm-cta-btn {
  flex: 0 0 auto;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 11px;
  border: none;
  background: #fff;
  color: #4c18cc;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 8px 20px rgba(18, 4, 52, 0.28);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.wnm-cta-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(18, 4, 52, 0.36);
}

/* ── Footer ── */
.wnm-footer {
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
/* The only persisting action — a subtle text button. */
.wnm-dnsa {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 8px 14px;
  border-radius: 10px;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.18s ease, background 0.18s ease;
}
.wnm-dnsa:hover { color: #fff; background: rgba(255, 255, 255, 0.1); }
.wnm-dnsa:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35); }

@media (max-width: 560px) {
  .wnm-inner { padding: 34px 22px 22px; }
  .wnm-title { font-size: 1.5rem; }
  .wnm-promo { flex-direction: column; align-items: flex-start; }
  .wnm-promo-cta { width: 100%; justify-content: center; }
  .wnm-cta { flex-direction: column; align-items: flex-start; }
  .wnm-cta-btn { margin-left: 0; width: 100%; justify-content: center; }
  .wnm-footer { align-items: stretch; }
  .wnm-dnsa { justify-content: center; }
}

@media (prefers-reduced-motion: reduce) {
  .wnm-promo { animation: none; }
  .wnm-marquee-track { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhatsNewModal.css"],"names":[],"mappings":"AAAA;;kEAEkE;;AAElE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;EACX,6CAA6C;EAC7C,6CAA6C;EAC7C,aAAa;AACf;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,0EAA0E;EAC1E,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA,mBAAmB,oCAAoC,EAAE,2BAA2B,EAAE;;AAEtF;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;EACpC,2CAA2C;EAC3C,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6DAA6D;EAC7D,iFAAiF;EACjF,eAAe;EACf,oBAAoB;EACpB,qDAAqD;EACrD,oDAAoD;AACtD;AACA;EACE,2BAA2B;EAC3B,gFAAgF;EAChF,eAAe;AACjB;AACA;EACE,WAAW,kHAAkH,EAAE;EAC/H,WAAW,kHAAkH,EAAE;AACjI;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,qDAAqD;EACrD,iBAAiB;EACjB,oBAAoB;EACpB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,6DAA6D;EAC7D,sFAAsF;AACxF;AACA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,cAAc,EAAE;AACjG,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAClG,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxE;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,gCAAgC;AAClC;AACA,kCAAkC,0BAA0B,EAAE;;AAE9D,oDAAoD;AACpD,YAAY,gBAAgB,EAAE;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,4EAA4E;EAC5E,cAAc;EACd,gBAAgB;EAEhB,gFAAgF;AAClF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;AACA,wCAAwC,4BAA4B,EAAE;AACtE;uFACuF;AACvF;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,qBAAqB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACrE;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;AAC7C;AACA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC/E,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC7E,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;AACtF;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4CAA4C;EAC5C,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,mDAAmD;AACrD;AACA,kBAAkB,WAAW,EAAE,oCAAoC,EAAE;AACrE,0BAA0B,aAAa,EAAE,+CAA+C,EAAE;;AAE1F;EACE,aAAa,uBAAuB,EAAE;EACtC,aAAa,iBAAiB,EAAE;EAChC,aAAa,sBAAsB,EAAE,uBAAuB,EAAE;EAC9D,iBAAiB,WAAW,EAAE,uBAAuB,EAAE;EACvD,WAAW,sBAAsB,EAAE,uBAAuB,EAAE;EAC5D,eAAe,cAAc,EAAE,WAAW,EAAE,uBAAuB,EAAE;EACrE,cAAc,oBAAoB,EAAE;EACpC,YAAY,uBAAuB,EAAE;AACvC;;AAEA;EACE,aAAa,eAAe,EAAE;EAC9B,qBAAqB,eAAe,EAAE;AACxC","sourcesContent":["/* WhatsNewModal — the agentic-upgrade announcement. Self-contained (wnm-*),\r\n   brand purple (#5e1bff family), DM Sans. The grid / glow / carousel / marquee\r\n   are ported 1:1 from the Wix-onboarding brand visual (.wav-*). */\r\n\r\n.wnm-panel {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 92%;\r\n  max-width: 760px;\r\n  max-height: 94vh;\r\n  overflow: hidden;\r\n  border-radius: 22px;\r\n  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);\r\n  color: #fff;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n  box-shadow: 0 34px 90px rgba(18, 4, 52, 0.55);\r\n  outline: none;\r\n}\r\n\r\n/* faint diagonal grid that fades toward the bottom — premium depth, no banding */\r\n.wnm-grid {\r\n  position: absolute;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);\r\n  background-size: 34px 34px;\r\n  -webkit-mask-image: radial-gradient(125% 80% at 78% 0%, #000 35%, transparent 80%);\r\n  mask-image: radial-gradient(125% 80% at 78% 0%, #000 35%, transparent 80%);\r\n  pointer-events: none;\r\n}\r\n.wnm-glow {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: radial-gradient(52% 38% at 82% 4%, rgba(255, 255, 255, 0.18), transparent 62%);\r\n  pointer-events: none;\r\n}\r\n\r\n.wnm-close {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  z-index: 3;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgba(255, 255, 255, 0.22);\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 0.9rem;\r\n  transition: background 0.2s, transform 0.2s;\r\n}\r\n.wnm-close:hover { background: rgba(255, 255, 255, 0.2); transform: translateY(-1px); }\r\n\r\n.wnm-inner {\r\n  position: relative;\r\n  z-index: 1;\r\n  max-height: 94vh;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 40px 40px 28px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* ── Header ── */\r\n.wnm-eyebrow {\r\n  display: inline-block;\r\n  align-self: flex-start;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.16em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.78);\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  padding: 5px 11px;\r\n  border-radius: 999px;\r\n  margin-bottom: 16px;\r\n}\r\n.wnm-title {\r\n  font-size: 1.86rem;\r\n  font-weight: 700;\r\n  line-height: 1.14;\r\n  letter-spacing: -0.018em;\r\n  margin: 0 0 10px;\r\n}\r\n.wnm-sub {\r\n  font-size: 0.96rem;\r\n  line-height: 1.5;\r\n  color: rgba(255, 255, 255, 0.82);\r\n  margin: 0 0 22px;\r\n  max-width: 96%;\r\n}\r\n\r\n/* ── Promo: the headline AI Studio, clickable straight into the builder.\r\n   A bright, near-white card that pops against the purple, with dark text. ── */\r\n.wnm-promo {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  width: 100%;\r\n  text-align: left;\r\n  margin: 2px 0 20px;\r\n  padding: 18px 20px;\r\n  border-radius: 18px;\r\n  border: 1px solid #fff;\r\n  background: linear-gradient(150deg, #ffffff 0%, #f3f1fb 100%);\r\n  box-shadow: 0 18px 40px rgba(18, 4, 52, 0.42), 0 0 0 1px rgba(124, 58, 237, 0.18);\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n  animation: wnm-promo-pulse 2.8s ease-in-out infinite;\r\n}\r\n.wnm-promo:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 24px 52px rgba(18, 4, 52, 0.5), 0 0 0 1px rgba(124, 58, 237, 0.34);\r\n  animation: none;\r\n}\r\n@keyframes wnm-promo-pulse {\r\n  0%, 100% { box-shadow: 0 18px 40px rgba(18, 4, 52, 0.42), 0 0 0 1px rgba(124, 58, 237, 0.18), 0 0 0 0 rgba(124, 58, 237, 0.3); }\r\n  50%      { box-shadow: 0 18px 40px rgba(18, 4, 52, 0.42), 0 0 0 1px rgba(124, 58, 237, 0.18), 0 0 0 8px rgba(124, 58, 237, 0); }\r\n}\r\n.wnm-promo-badge {\r\n  position: absolute;\r\n  top: -9px;\r\n  left: 18px;\r\n  font-size: 10px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.14em;\r\n  text-transform: uppercase;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, #7c3aed, #5616ea);\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  box-shadow: 0 4px 12px rgba(86, 22, 234, 0.45);\r\n}\r\n.wnm-promo-icon {\r\n  flex: 0 0 auto;\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 13px;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 1.25rem;\r\n  color: #fff;\r\n  background: linear-gradient(145deg, #b794ff 0%, #6d28d9 100%);\r\n  box-shadow: 0 6px 16px rgba(76, 24, 204, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.45);\r\n}\r\n.wnm-promo-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1 1 auto; }\r\n.wnm-promo-title { font-size: 1.18rem; font-weight: 800; letter-spacing: -0.01em; color: #1c1535; }\r\n.wnm-promo-desc { font-size: 0.85rem; line-height: 1.4; color: #5b5570; }\r\n.wnm-promo-cta {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border-radius: 11px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  box-shadow: 0 8px 20px rgba(86, 22, 234, 0.4);\r\n  transition: transform 0.18s ease;\r\n}\r\n.wnm-promo:hover .wnm-promo-cta { transform: translateX(2px); }\r\n\r\n/* ── Marquee: everything the agent connects to ── */\r\n.wnm-more { margin-top: 22px; }\r\n.wnm-more-label {\r\n  font-size: 10.5px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.1em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n.wnm-marquee {\r\n  margin-top: 12px;\r\n  /* Vertical room so a logo's hover-lift isn't clipped by overflow: hidden. */\r\n  padding: 8px 0;\r\n  overflow: hidden;\r\n  -webkit-mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\r\n  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\r\n}\r\n.wnm-marquee-track {\r\n  display: flex;\r\n  width: max-content;\r\n  animation: wnm-marquee 28s linear infinite;\r\n}\r\n.wnm-marquee:hover .wnm-marquee-track { animation-play-state: paused; }\r\n/* Each logo is wrapped in InfoTooltip — its .info-tooltip-wrapper is the flex item,\r\n   so the loop spacing lives on the wrapper (the duplicated track still slides -50%). */\r\n.wnm-marquee-track .info-tooltip-wrapper {\r\n  flex: 0 0 auto;\r\n  margin: 0 9px 0 0;\r\n}\r\n.wnm-more-logo {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 9px;\r\n  background: #fff;\r\n  display: grid;\r\n  place-items: center;\r\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.14);\r\n  cursor: pointer;\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\r\n}\r\n.wnm-more-logo:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);\r\n}\r\n.wnm-more-logo img { width: 21px; height: 21px; object-fit: contain; }\r\n@keyframes wnm-marquee {\r\n  from { transform: translateX(0); }\r\n  to   { transform: translateX(-50%); }\r\n}\r\n\r\n/* ── Calendly CTA ── */\r\n.wnm-cta {\r\n  margin-top: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  padding: 16px 18px;\r\n  border-radius: 16px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n}\r\n.wnm-cta-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }\r\n.wnm-cta-title { font-size: 1rem; font-weight: 700; letter-spacing: -0.01em; }\r\n.wnm-cta-sub { font-size: 0.84rem; line-height: 1.4; color: rgba(255, 255, 255, 0.8); }\r\n.wnm-cta-btn {\r\n  flex: 0 0 auto;\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 11px 18px;\r\n  border-radius: 11px;\r\n  border: none;\r\n  background: #fff;\r\n  color: #4c18cc;\r\n  font-family: inherit;\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  box-shadow: 0 8px 20px rgba(18, 4, 52, 0.28);\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\r\n}\r\n.wnm-cta-btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 12px 26px rgba(18, 4, 52, 0.36);\r\n}\r\n\r\n/* ── Footer ── */\r\n.wnm-footer {\r\n  margin-top: 22px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 14px;\r\n}\r\n/* The only persisting action — a subtle text button. */\r\n.wnm-dnsa {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  padding: 8px 14px;\r\n  border-radius: 10px;\r\n  border: none;\r\n  background: transparent;\r\n  font-family: inherit;\r\n  font-size: 0.84rem;\r\n  font-weight: 600;\r\n  color: rgba(255, 255, 255, 0.72);\r\n  cursor: pointer;\r\n  user-select: none;\r\n  text-decoration: underline;\r\n  text-underline-offset: 3px;\r\n  transition: color 0.18s ease, background 0.18s ease;\r\n}\r\n.wnm-dnsa:hover { color: #fff; background: rgba(255, 255, 255, 0.1); }\r\n.wnm-dnsa:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35); }\r\n\r\n@media (max-width: 560px) {\r\n  .wnm-inner { padding: 34px 22px 22px; }\r\n  .wnm-title { font-size: 1.5rem; }\r\n  .wnm-promo { flex-direction: column; align-items: flex-start; }\r\n  .wnm-promo-cta { width: 100%; justify-content: center; }\r\n  .wnm-cta { flex-direction: column; align-items: flex-start; }\r\n  .wnm-cta-btn { margin-left: 0; width: 100%; justify-content: center; }\r\n  .wnm-footer { align-items: stretch; }\r\n  .wnm-dnsa { justify-content: center; }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .wnm-promo { animation: none; }\r\n  .wnm-marquee-track { animation: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
